import {
  AItoolsmenu,
  examPrepAndFlashCards,
} from "../../../constants/library";
import { Backtotop, Floatinmenu, Underline,AI_tools_part_two } from "../../../widgets";
import "../../Library/AI_bots.css";
import { RadialMenu} from "../../../components";
import { FaMicrochip } from "react-icons/fa";

export default function Examprep() {

    return (
        <>
      <div className="librarypage">
            <div className="librarybg">
                <div className="libraryheading">AI - Tools</div>
                <div className="library_sub_heading">Exam Preparation</div>
            </div>
        </div>
        <section className="librarydark">
            <div className="dept_float_menu">
                <Floatinmenu logo={FaMicrochip} head="Menu" links={AItoolsmenu} />
            </div>
            <RadialMenu menu_links={AItoolsmenu} />
            <Underline heading="Exam Preparation" />
            <div  style={{ display: 'flex', flexWrap: 'wrap' }}>
                 {examPrepAndFlashCards.map((tool, index) => (
        <AI_tools_part_two key={index} {...tool} />
      ))}
            </div>
        </section>
        <Backtotop />

        </>
    )
}